(function($) {

	$.fn.initHomehero = function() {

		var _this = this;

		_this.addClass("preparing");
		window.setTimeout(function() {
			_this.addClass("animated").removeClass("preparing");
		}, 500);

		return this;
	}

})(jQuery);
